import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { connect, ConnectedProps } from 'react-redux'
import { RootState } from '../../store'
import routes from '../../routes/routes'
import billOfLadingApi from '../../apis/billOfLading.api'
import downloadService from '../../services/download.service'
import alertService from '../../services/alert.service'
import { paginate } from './BillsOfLading.thunk'
import { replacePage, replaceLimit, replaceSearch } from './BillsOfLading.slice'
import Button from '../../components/Button'
import Card from '../../components/Card'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import DataTable from '../../components/DataTable'
import HeadingRow from '../../components/HeadingRow'
import { TableHorizontalHeader } from '../../components/TableHorizontal'
import { ActionName } from '../../components/Actions'

interface BillsOfLadingProps
  extends RouteComponentProps, ConnectedProps<typeof connector> {}

class BillsOfLading extends Component<BillsOfLadingProps> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n("Ship order"), path: 'shipOrder.code' },
    { heading: i18n("Purchase order"), path: 'shipOrder.purchaseOrder' },
    { heading: i18n("Sales order"), path: 'shipOrder.salesOrder' },
    { heading: i18n("BOL"), path: 'code' },
    { heading: i18n("Created at"),
      path: 'createdAt',
      date: true,
      tooltip: ['createdUser.username']
    },
    { heading: i18n("Actions") }
  ]

  constructor (props: BillsOfLadingProps) {
    super(props)
    this.handleLimitChange = this.handleLimitChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handlePaginate = this.handlePaginate.bind(this)
    this.handleExportClick = this.handleExportClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  handleLimitChange (limit: string) {
    this.props.replaceLimit(Number(limit))
  }

  handleSearch (search: string) {
    this.props.replaceSearch(search)
  }

  handlePaginate (page: number) {
    this.props.replacePage(page)
  }

  handleExportClick () {
    billOfLadingApi.export(billsOfLading => {
      if (!billsOfLading) {
        alertService.info('No results to export')
        return
      }
      downloadService.download(billsOfLading, 'billsOfLading.csv')
    })
  }

  handleActionClick (id: number, action: ActionName) {
    if (action === 'generate') {
      const pathname = routes.billOfLadingGenerate
      const state = { id }
      this.props.history.push({ pathname, state })
    }
  }

  componentDidMount () {
    this.props.paginate()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <HeadingRow
              heading={i18n("Bills of Lading")}
              doc='bills-of-lading'>
              <Button
                text={i18n("Export")}
                onClick={this.handleExportClick} />
            </HeadingRow>
            <DataTable
              headers={this.headers}
              data={this.props.data}
              total={this.props.total}
              from={this.props.from}
              to={this.props.to}
              currentPage={this.props.currentPage}
              lastPage={this.props.lastPage}
              limit={String(this.props.limit)}
              search={this.props.search}
              onLimtChange={this.handleLimitChange}
              onSearch={this.handleSearch}
              onPaginate={this.handlePaginate}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

const mapStateToProps = (state: RootState) => {
  const { result, limit, search } = state.billsOfLading
  const { data, total, from, to, currentPage, lastPage } = result
  return { data, total, from, to, currentPage, lastPage, limit, search }
}

const mapDispatchToProps = {
  paginate,
  replacePage,
  replaceLimit,
  replaceSearch
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(withRouter(BillsOfLading))
